Vue.asyncComponent('cms-profile', {
    data() {
        return {
        }
    }
}, 'cms/account/cms-profile.html');